import { render } from "./HeadIndivid.vue?vue&type=template&id=70070a6e&scoped=true"
import script from "./HeadIndivid.vue?vue&type=script&lang=js"
export * from "./HeadIndivid.vue?vue&type=script&lang=js"

import "./HeadIndivid.vue?vue&type=style&index=0&id=70070a6e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70070a6e"]])

export default __exports__